import { useEffect, useState } from "react";
import { IIPAddressProps } from "./IIPAddressProps";
import { IAsyncBoundProperties } from "../../../base/hooks";
import { FetchStatus } from "../../../base/types";

export const IPAddresseProperties = [
]

export const useIPAddress = (props: IAsyncBoundProperties) => {
    const { status, result: bindings, error } = props;
    const [properties, ] = useState<IIPAddressProps>()

    useEffect(() => {
        if (status !== FetchStatus.Success || !bindings)
            return;
        // eslint-disable-next-line
    }, [bindings, status]);

    return { status, error, bindings, properties }
}

